import { Form, Input, message } from "components/common";
import React from "react";
import { Wrapper } from "./AddExpenseCategory.styled";

const AddExpenseCategory = ({ formData, setFormData }) => {
  return (
    <Wrapper>
      <Form name="basic" autoComplete="off">
        <Form.Item
        name="name"
          rules={[
            {
              required: true,
              message: "Please Enter Filed",
            },
          ]}
        >
          <label className="modal-label">Category name:</label>
          <Input
            type="text"
            className="modal-input"
            placeholder="Enter Expense category"
            value={formData?.name}
            onChange={(e) => {
              setFormData({
                ...formData,
                name: e.target.value,
              });
            }}
          />
        </Form.Item>
      </Form>
    </Wrapper>
  );
};

export default AddExpenseCategory;
